import { createCardExtension, homePlugin } from '@backstage/plugin-home';

export const HomePageMyComponents = homePlugin.provide(
  createCardExtension({
    title: 'My Components',
    components: () => import('./MyComponents'),
  }),
);

export const HomePagePlatformDevTools = homePlugin.provide(
  createCardExtension({
    title: 'Platform Tools',
    components: () => import('./PlatformDevTools'),
  }),
);

export const HomePageWelcome = homePlugin.provide(
  createCardExtension({
    title: 'Welcome',
    components: () => import('./Welcome'),
  }),
);
